export default "__VITE_ASSET__6Lm42WqA__"